import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/icon/check-circle-blue.svg'
import _imports_1 from '@/assets/img/icon/check-circle-green.svg'
import _imports_2 from '@/assets/img/icon/ic-color-money.svg'
import _imports_3 from '@/assets/img/icon/ic-color-cc.svg'
import _imports_4 from '@/assets/img/icon/calendar-outline-black.svg'
import _imports_5 from '@/assets/img/icon/arrow-circle-right-outline-blue.svg'
import _imports_6 from '@/assets/img/icon/steering-wheel-outline-black.svg'
import _imports_7 from '@/assets/img/icon/edit-solid-blue.svg'
import _imports_8 from '@/assets/img/icon/penalty-yellow.svg'
import _imports_9 from '@/assets/img/icon/bus-fill-blue.svg'
import _imports_10 from '@/assets/img/icon/bus-fill-yellow.svg'
import _imports_11 from '@/assets/img/icon/verbal-report-red.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { class: "md:flex justify-between items-center" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-2xl font-bold mr-3 break-all" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center ml-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 text-primary text-base font-bold" }, "Approved", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_1,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 text-green text-base font-bold" }, "Approve", -1)
const _hoisted_12 = {
  key: 1,
  class: "flex items-center cursor-not-allowed"
}
const _hoisted_13 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 text-light-green text-base font-bold" }, "Approve", -1)
const _hoisted_15 = { class: "text-grey text-sm font-bold" }
const _hoisted_16 = { class: "bg-neutral-100 mb-5" }
const _hoisted_17 = { class: "md:grid md:grid-cols-3 border-grey-2 py-2 rounded-t-md" }
const _hoisted_18 = { class: "p-2 border-r border-neutral300" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "label-xs mb-1.5" }, "Kondektur", -1)
const _hoisted_20 = { class: "text-sm text-center font-bold break-all" }
const _hoisted_21 = { class: "p-2 border-r border-neutral300" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "label-xs mb-1.5" }, "Supir", -1)
const _hoisted_23 = { class: "text-sm text-center font-bold break-all" }
const _hoisted_24 = { class: "p-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "label-xs mb-1.5" }, "Kendaraan", -1)
const _hoisted_26 = { class: "text-sm text-center font-bold break-all" }
const _hoisted_27 = { class: "md:grid md:grid-cols-2 border-grey-2 py-2 rounded-b-md" }
const _hoisted_28 = { class: "p-2 border-r border-neutral300" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "label-xs mb-1.5" }, "Total Penumpang", -1)
const _hoisted_30 = { class: "text-base text-center font-bold text-primary" }
const _hoisted_31 = { class: "p-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "label-xs mb-1.5" }, "Jumlah Pendapatan", -1)
const _hoisted_33 = { class: "flex items-center justify-center gap-4" }
const _hoisted_34 = { class: "flex items-center justify-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_36 = { class: "text-base text-center font-bold text-primary ml-1.5" }
const _hoisted_37 = { class: "flex items-center justify-center" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_39 = { class: "text-base text-center font-bold text-primary ml-1.5" }
const _hoisted_40 = { class: "mb-5" }
const _hoisted_41 = { class: "w-full flex" }
const _hoisted_42 = { class: "bg-primary400 px-6 py-3 rounded-md w-full md:flex justify-between items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-extrabold break-words mb-3 md:mb-0" }, "Detail Pendapatan dan pengeluaran", -1)
const _hoisted_44 = { class: "flex gap-3" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "map-box" }
const _hoisted_47 = { class: "map-box-header" }
const _hoisted_48 = { class: "text-lg font-semibold mb-1.5" }
const _hoisted_49 = { class: "md:flex gap-3.5" }
const _hoisted_50 = { class: "flex items-center mb-2 md:mb-0" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "w-[14px] h-[14px] mr-1"
}, null, -1)
const _hoisted_52 = { class: "text-xs text-neutral500" }
const _hoisted_53 = { class: "flex items-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "w-[14px] h-[14px] mr-1"
}, null, -1)
const _hoisted_55 = { class: "text-xs text-neutral500 font-bold" }
const _hoisted_56 = { class: "flex items-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "w-[14px] h-[14px] mr-1"
}, null, -1)
const _hoisted_58 = { class: "text-xs text-neutral500 font-bold" }
const _hoisted_59 = { class: "md:grid grid-cols-2 gap-5" }
const _hoisted_60 = { class: "bg-neutral rounded-xl background-semiwhite-1 border-grey-2 w-full p-4 mb-5 md:mb-0" }
const _hoisted_61 = { class: "flex items-center gap-4 mb-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold text-neutral-dark" }, "Pendapatan", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Lihat Detail '), -1)
const _hoisted_64 = { class: "mb-4 border-bottom-grey-5" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm font-semibold" }, "Pendapatan Tiket")
], -1)
const _hoisted_66 = { class: "px-3" }
const _hoisted_67 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-2/5" }, "Dari - Ke"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left w-1/5" }, "Jumlah"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-right w-2/5" }, "Nominal")
  ])
], -1)
const _hoisted_69 = { class: "text-sm" }
const _hoisted_70 = { class: "w-2/5 pr-3" }
const _hoisted_71 = { class: "text-left w-1/5" }
const _hoisted_72 = { class: "text-right w-2/5 pl-3" }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-xs text-center"
}, "- Kosong -", -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "mb-4" }
const _hoisted_77 = { class: "flex items-center justify-between" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-sm font-semibold" }, "Pendapatan Lain - Lain", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: ""
}, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-extrabold text-primary" }, "Edit", -1)
const _hoisted_81 = [
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = { class: "px-3" }
const _hoisted_83 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_84 = { class: "text-sm" }
const _hoisted_85 = { class: "w-2/5 pr-3" }
const _hoisted_86 = { class: "text-left w-1/5" }
const _hoisted_87 = { class: "text-right w-2/5 pl-3" }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-xs text-center"
}, "- Kosong -", -1)
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "flex items-center justify-between" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "font-extrabold text-base text-neutral-dark" }, "Grand Total", -1)
const _hoisted_93 = { class: "font-extrabold text-base text-right text-neutral-dark" }
const _hoisted_94 = { class: "bg-neutral rounded-xl w-full p-4 background-semiwhite-1 border-grey-2" }
const _hoisted_95 = { class: "flex items-center justify-between" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold text-neutral-dark" }, "Pengeluaran", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: ""
}, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-extrabold text-primary" }, "Edit", -1)
const _hoisted_99 = [
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = {
  key: 0,
  class: "md:flex items-center gap-2 mb-4"
}
const _hoisted_101 = { class: "text-xs text-grey" }
const _hoisted_102 = { class: "px-3" }
const _hoisted_103 = { class: "w-full table-variant text-neutral500" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-left" }, "Jenis Pengeluaran"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs text-right" }, "Nominal")
  ])
], -1)
const _hoisted_105 = { class: "text-sm" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { class: "flex items-center gap-2" }
const _hoisted_108 = { class: "text-right" }
const _hoisted_109 = {
  key: 0,
  class: "italic text-grey text-xs"
}
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { class: "flex items-center gap-2" }
const _hoisted_112 = { class: "text-right" }
const _hoisted_113 = {
  key: 0,
  class: "italic text-grey text-xs"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: ""
}, null, -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-extrabold text-primary" }, "Edit", -1)
const _hoisted_116 = [
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = { key: 2 }
const _hoisted_118 = {
  colspan: "2",
  class: "!py-0 border-b border-neutral-200"
}
const _hoisted_119 = {
  key: 0,
  class: "w-full"
}
const _hoisted_120 = { class: "flex flex-col gap-2 flex-1" }
const _hoisted_121 = { class: "font-bold text-sm text-neutral-dark" }
const _hoisted_122 = { class: "flex items-center gap-4 text-sm text-neutral-600" }
const _hoisted_123 = { class: "flex items-center gap-1.5 whitespace-nowrap" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file text-neutral-400" }, null, -1)
const _hoisted_125 = { class: "font-bold" }
const _hoisted_126 = { class: "flex items-center gap-1.5 whitespace-nowrap" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-4 h-4 grayscale opacity-70"
}, null, -1)
const _hoisted_128 = { class: "font-bold text-primary" }
const _hoisted_129 = { class: "text-right" }
const _hoisted_130 = ["onClick"]
const _hoisted_131 = /*#__PURE__*/_createTextVNode(" Lihat Detail ")
const _hoisted_132 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right text-xs" }, null, -1)
const _hoisted_133 = [
  _hoisted_131,
  _hoisted_132
]
const _hoisted_134 = {
  key: 1,
  class: "py-2 text-sm text-neutral-500 italic"
}
const _hoisted_135 = { class: "text-base" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("td", { class: "font-extrabold text-neutral-dark" }, "Grand Total", -1)
const _hoisted_137 = { class: "font-extrabold text-right text-neutral-dark" }
const _hoisted_138 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_139 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xs text-greyt" }, [
  /*#__PURE__*/_createElementVNode("em", null, "- Tidak ada rit -")
], -1)
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = { class: "mt-5" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-xl font-bold" }, "Denda", -1)
const _hoisted_143 = {
  key: 0,
  class: "rounded-xl w-full p-4 background-semiwhite-1 border-grey-2"
}
const _hoisted_144 = { class: "md:flex items-center justify-between" }
const _hoisted_145 = { class: "flex gap-3 items-center" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: ""
}, null, -1)
const _hoisted_147 = { class: "text-lg font-bold" }
const _hoisted_148 = { class: "text-lg font-bold" }
const _hoisted_149 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("em", null, "- Tidak Ada Data -", -1)
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = { class: "mt-5" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-xl font-bold" }, "Kontroller", -1)
const _hoisted_154 = { class: "text-xl font-extrabold mb-4" }
const _hoisted_155 = { class: "md:flex items-center justify-between mb-4" }
const _hoisted_156 = { class: "md:w-1/3" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    class: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey font-extrabold text-base" }, "Detail Naik")
], -1)
const _hoisted_158 = { class: "font-normal text-sm" }
const _hoisted_159 = { class: "font-normal text-sm" }
const _hoisted_160 = { class: "md:w-1/3" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    class: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey font-extrabold text-base" }, "Detail Turun")
], -1)
const _hoisted_162 = { class: "font-normal text-sm" }
const _hoisted_163 = { class: "font-normal text-sm" }
const _hoisted_164 = { class: "rounded-xl w-full p-3 background-grey-3 mb-4" }
const _hoisted_165 = {
  key: 0,
  class: "text-sm font-semibold"
}
const _hoisted_166 = { key: 1 }
const _hoisted_167 = { class: "flex items-center justify-between" }
const _hoisted_168 = { class: "text-sm font-semibold" }
const _hoisted_169 = ["onClick"]
const _hoisted_170 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_171 = { class: "flex items-center justify-between gap-5" }
const _hoisted_172 = { class: "flex items-center gap-3" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  class: "",
  width: "40",
  height: "40"
}, null, -1)
const _hoisted_174 = { class: "" }
const _hoisted_175 = { class: "text-base font-semibold" }
const _hoisted_176 = { class: "text-grey text-sm font-400" }
const _hoisted_177 = ["onClick"]
const _hoisted_178 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_179 = /*#__PURE__*/_createElementVNode("em", null, "- Tidak Ada Data -", -1)
const _hoisted_180 = [
  _hoisted_179
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_SnackSummary = _resolveComponent("SnackSummary")!
  const _component_HjpTabView = _resolveComponent("HjpTabView")!
  const _component_Card = _resolveComponent("Card")!
  const _component_IncomeTicketsDetail = _resolveComponent("IncomeTicketsDetail")!
  const _component_UpdateExpense = _resolveComponent("UpdateExpense")!
  const _component_FuelingTransactionRevision = _resolveComponent("FuelingTransactionRevision")!
  const _component_ExpenseHistory = _resolveComponent("ExpenseHistory")!
  const _component_ApproveModal = _resolveComponent("ApproveModal")!
  const _component_UpdateOtherRevenues = _resolveComponent("UpdateOtherRevenues")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        (!_ctx.isLoading && _ctx.dataSource)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dataSource.TrxId), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-xl md:text-2xl font-bold", _ctx.dataSource.RosterStatusCode === 'PRW' ? 'text-orange-1' : _ctx.dataSource.RosterStatusCode === 'GBG' ? 'text-green' : 'text-primary'])
                    }, _toDisplayString(`(${_ctx.dataSource.RosterStatusName})`), 3),
                    (_ctx.dataSource.IsApproved)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.dataSource.IsApproved && _ctx.isAllApproved)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        onClick: _ctx.approveAct,
                        class: "flex items-center btn-success-outline"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (!_ctx.dataSource.IsApproved)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_Popper, {
                                arrow: "",
                                hover: "",
                                placement: "left",
                                content: _ctx.tooltipText
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }, 8, ["content"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(`Keterangan Roster : ${_ctx.dataSource.RosterStatusRemark ?? '-'}`), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.dataSource.CondecturName ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.dataSource.DriverName ?? '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.dataSource.VehicleRegNumber ?? '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(`${_ctx.dataSource.TotalTicketPpSold} Orang`), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.currencyNumberFormat(_ctx.dataSource.TotalTicketPpAmountOffline + _ctx.dataSource.TotalSnackNetAmountCash)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.currencyNumberFormat(_ctx.dataSource.TotalTicketPpAmountOnline + _ctx.dataSource.TotalSnackNetAmountNonCash)), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_SnackSummary, { dataHeader: _ctx.dataSource }, null, 8, ["dataHeader"])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("button", {
                      class: "bg-white border border-neutral400 text-neutral500 rounded-lg py-2 px-6 w-24 transition-all font-extrabold hover:opacity-90",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printClosedStat(_ctx.dataSource)))
                    }, "View")
                  ])
                ])
              ]),
              (_ctx.dataSource?.Rits?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createVNode(_component_HjpTabView, {
                      onTabsChange: _ctx.tabsChange,
                      tabHeader: _ctx.ritList,
                      currActive: _ctx.currTabIndex
                    }, null, 8, ["onTabsChange", "tabHeader", "currActive"]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.dataSource.RosterCode), 1),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _hoisted_51,
                            _createElementVNode("div", _hoisted_52, _toDisplayString(`${_ctx.moment(_ctx.dataRitDetail?.StartDate.toString()).format('DD MMMM YYYY')} at
                                        ${_ctx.moment(_ctx.dataRitDetail?.StartDate.toString()).format('HH.mm')}`), 1)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("div", _hoisted_55, _toDisplayString(`${_ctx.dataRitDetail?.RouteName} ( Rit ${_ctx.dataRitDetail?.RitOrder} )`), 1)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.dataRitDetail?.DriverName), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _createVNode(_component_Button, {
                            class: "flex gap-2 extra-submit-button text-primary detail-tickets",
                            onClick: _ctx.showDialogIncomeTicketsDetail,
                            outlined: true
                          }, {
                            default: _withCtx(() => [
                              _hoisted_63
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("table", _hoisted_67, [
                              _hoisted_68,
                              _createElementVNode("tbody", _hoisted_69, [
                                (_ctx.dataRitDetail?.TotalTicketGroupByOriginDestination && _ctx.dataRitDetail?.TotalTicketGroupByOriginDestination.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataRitDetail?.TotalTicketGroupByOriginDestination, (dataProfit, key) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                        _createElementVNode("td", _hoisted_70, _toDisplayString(`${dataProfit.OriginTerminalCode ?? ''} -
                                                  ${dataProfit.DestinationTerminalCode ?? ''}`), 1),
                                        _createElementVNode("td", _hoisted_71, _toDisplayString(`${dataProfit.TotalTicketSold} Orang`), 1),
                                        _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.currencyNumberFormat(dataProfit.TotalTicketAmount)), 1)
                                      ]))
                                    }), 128))
                                  : (_openBlock(), _createElementBlock("tr", _hoisted_73, _hoisted_75))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _hoisted_78,
                            (!_ctx.dataSource.IsApproved && _ctx.checkProhibitedRoles(['Roster']))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "flex items-center gap-1 cursor-pointer",
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showDialogUpdateOtherRevenue && _ctx.showDialogUpdateOtherRevenue(...args)))
                                }, _hoisted_81))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("table", _hoisted_83, [
                              _createElementVNode("tbody", _hoisted_84, [
                                (_ctx.dataRitDetail?.RitOtherRevenues && _ctx.dataRitDetail?.RitOtherRevenues.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataRitDetail?.RitOtherRevenues, (dataProfit, key) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                        _createElementVNode("td", _hoisted_85, _toDisplayString(dataProfit.RevenueName ?? ''), 1),
                                        _createElementVNode("td", _hoisted_86, _toDisplayString(`${dataProfit.Quantity} Orang`), 1),
                                        _createElementVNode("td", _hoisted_87, _toDisplayString(_ctx.currencyNumberFormat(dataProfit.Value)), 1)
                                      ]))
                                    }), 128))
                                  : (_openBlock(), _createElementBlock("tr", _hoisted_88, _hoisted_90))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _hoisted_92,
                          _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.currencyNumberFormat(_ctx.grandTotalIncome)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _hoisted_96,
                          (!_ctx.dataSource.IsApproved)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "flex items-center gap-1 cursor-pointer",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDialogUpdateExpense && _ctx.showDialogUpdateExpense(...args)))
                              }, _hoisted_99))
                            : _createCommentVNode("", true)
                        ]),
                        (!_ctx.isNull(_ctx.latestRevisionDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, _toDisplayString(`Last edit: ${_ctx.moment(_ctx.latestRevisionDate).format('DD MMMM YYYY')} at
                                    ${_ctx.moment(_ctx.latestRevisionDate).format('HH:mm:ss')}`), 1),
                              _createElementVNode("div", {
                                class: "text-xs font-extrabold text-primary cursor-pointer",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDialogExpenseHistory && _ctx.showDialogExpenseHistory(...args)))
                              }, "Lihat Riwayat")
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("table", _hoisted_103, [
                            _hoisted_104,
                            _createElementVNode("tbody", _hoisted_105, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestExpenseRevision, (dataExpense, idx) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                                  (dataExpense.ExpenseName !== 'Solar Bon')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_106, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_107, _toDisplayString(dataExpense.ExpenseName), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_108, [
                                          (_ctx.isExpenseDisabled(dataExpense.ExpenseName))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_109, " (Tidak dapat diedit) "))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(_ctx.currencyNumberFormat(dataExpense.Nominal ?? 0)), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_110, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_111, [
                                            _createElementVNode("span", null, _toDisplayString(dataExpense.ExpenseName), 1),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "focus:outline-none flex items-center cursor-pointer text-neutral-500 hover:text-neutral-700",
                                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSolarBon && _ctx.toggleSolarBon(...args)))
                                            }, [
                                              _createElementVNode("i", {
                                                class: _normalizeClass(["pi text-xs", _ctx.isSolarBonExpanded ? 'pi-chevron-up' : 'pi-chevron-down'])
                                              }, null, 2)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("td", _hoisted_112, [
                                          (_ctx.isExpenseDisabled(dataExpense.ExpenseName))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_113, " (Tidak dapat diedit) "))
                                            : (!_ctx.dataSource.IsApproved && dataExpense.Nominal > 0)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  class: "inline-flex items-center gap-1 cursor-pointer mr-3",
                                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showDialogFuelingTransactionRevision && _ctx.showDialogFuelingTransactionRevision(...args)))
                                                }, _hoisted_116))
                                              : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(_ctx.currencyNumberFormat(dataExpense.Nominal ?? 0)), 1)
                                        ])
                                      ])),
                                  (dataExpense.ExpenseName === 'Solar Bon' && _ctx.isSolarBonExpanded)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_117, [
                                        _createElementVNode("td", _hoisted_118, [
                                          (_ctx.dieselExpenseDetailList && _ctx.dieselExpenseDetailList.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dieselExpenseDetailList, (dataDieselDetail, idDetail) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: idDetail,
                                                    class: "flex items-center justify-between gap-4 py-3 border-t border-gray-100 first:border-t-0"
                                                  }, [
                                                    _createElementVNode("div", _hoisted_120, [
                                                      _createElementVNode("span", _hoisted_121, _toDisplayString(dataDieselDetail.FuelStationPartnerName || '-'), 1),
                                                      _createElementVNode("div", _hoisted_122, [
                                                        _createElementVNode("div", _hoisted_123, [
                                                          _hoisted_124,
                                                          _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.numberFormat(dataDieselDetail.Liters ?? 0)) + " L", 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_126, [
                                                          _hoisted_127,
                                                          _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.currencyNumberFormat(dataDieselDetail.Price ?? 0)), 1)
                                                        ])
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_129, [
                                                      _createElementVNode("a", {
                                                        href: "#",
                                                        class: "text-blue-500 hover:text-blue-600 text-sm font-semibold flex items-center justify-end gap-1 whitespace-nowrap",
                                                        onClick: _withModifiers(($event: any) => (_ctx.navigateToFuelingDetail(dataDieselDetail.Id)), ["prevent"])
                                                      }, _hoisted_133, 8, _hoisted_130)
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_134, " Tidak ada data transaksi. "))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _createElementVNode("tfoot", _hoisted_135, [
                              _createElementVNode("tr", null, [
                                _hoisted_136,
                                _createElementVNode("td", _hoisted_137, _toDisplayString(_ctx.currencyNumberFormat(_ctx.grandtotalExpense)), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_138, _hoisted_140)),
              _createElementVNode("div", _hoisted_141, [
                _hoisted_142,
                (_ctx.dataRitDetail?.Verpals !== null && _ctx.dataRitDetail?.Verpals.VerpalDetails.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                      _createElementVNode("div", _hoisted_144, [
                        _createElementVNode("div", _hoisted_145, [
                          _hoisted_146,
                          _createElementVNode("div", _hoisted_147, _toDisplayString(`${_ctx.dataRitDetail?.Verpals.VerpalDetails.length} Tiket Refund`), 1)
                        ]),
                        _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.currencyNumberFormat(_ctx.totalPenalty)), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_149, _hoisted_151))
              ]),
              _createElementVNode("div", _hoisted_152, [
                _hoisted_153,
                (_ctx.dataRitDetail && _ctx.dataRitDetail?.Controllers.length > 0)
                  ? (_openBlock(), _createBlock(_component_Card, {
                      key: 0,
                      class: "card-no-shadow mb-4"
                    }, {
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataRitDetail?.Controllers, (data) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "mb-4 border-bottom-grey-lighten-5 p-3",
                            key: data.Id
                          }, [
                            _createElementVNode("div", _hoisted_154, _toDisplayString(data.ControllerName), 1),
                            _createElementVNode("div", _hoisted_155, [
                              _createElementVNode("div", _hoisted_156, [
                                _hoisted_157,
                                _createElementVNode("div", _hoisted_158, _toDisplayString(`${data.BoardStationName === '' || data.BoardStationName === null ? '-' : data.BoardStationName},
                                            ${_ctx.moment(data.BoardTime.toString()).format('LT')}`), 1),
                                _createElementVNode("div", _hoisted_159, _toDisplayString(data.BoardVerbatim === '' || data.BoardVerbatim === null ? '-' :
                      data.BoardVerbatim), 1)
                              ]),
                              _createElementVNode("div", _hoisted_160, [
                                _hoisted_161,
                                _createElementVNode("div", _hoisted_162, _toDisplayString(`${data.DropoffStationName === '' || data.DropoffStationName === null ? '-' :
                        data.DropoffStationName}, ${_ctx.moment(data.DropoffTime.toString()).format('LT')}`), 1),
                                _createElementVNode("div", _hoisted_163, _toDisplayString(data.DropoffVerbatim === '' || data.DropoffVerbatim === null ? '-' : data.DropoffVerbatim), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_164, [
                              (data.Verbals.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_165, "Tidak Ada Laporan Verbal"))
                                : (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                    _createElementVNode("div", _hoisted_167, [
                                      _createElementVNode("div", _hoisted_168, _toDisplayString(`Lihat ${data.Verbals.length} laporan verbal`), 1),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("span", null, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(_ctx.showControllerListId === data.Id ? 'pi pi-angle-right text-xl font-medium cursor-pointer' : 'pi pi-angle-down text-xl font-medium cursor-pointer'),
                                            onClick: ($event: any) => (_ctx.openControllersList(data.Id))
                                          }, null, 10, _hoisted_169)
                                        ])
                                      ])
                                    ]),
                                    (_ctx.showControllerListId === data.Id)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.Verbals, (dataVerbal) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "rounded-xl w-full p-4 background-semiwhite-1 mb-4",
                                              key: dataVerbal.Id
                                            }, [
                                              _createElementVNode("div", _hoisted_171, [
                                                _createElementVNode("div", _hoisted_172, [
                                                  _hoisted_173,
                                                  _createElementVNode("div", _hoisted_174, [
                                                    _createElementVNode("div", _hoisted_175, _toDisplayString(dataVerbal.Title), 1),
                                                    _createElementVNode("div", _hoisted_176, _toDisplayString(dataVerbal.Verbatim), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("div", {
                                                  class: "text-center w-26 text-base text-primary font-bold cursor-pointer",
                                                  onClick: ($event: any) => (_ctx.openVerbalDetail(dataVerbal.Id))
                                                }, "Lihat Detail", 8, _hoisted_177)
                                              ])
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_178, _hoisted_180))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isShowDialogIncomeTicketsDetail)
      ? (_openBlock(), _createBlock(_component_IncomeTicketsDetail, {
          key: 0,
          show: _ctx.isShowDialogIncomeTicketsDetail,
          dataDetail: _ctx.dataIncomeDetail,
          ritId: _ctx.activeRitId,
          filterOptions: _ctx.incomeDetailFilterOptions,
          onHideDialog: _ctx.hideDialogIncomeTicketsDetail
        }, null, 8, ["show", "dataDetail", "ritId", "filterOptions", "onHideDialog"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDialogUpdateExpense)
      ? (_openBlock(), _createBlock(_component_UpdateExpense, {
          key: 1,
          trxId: _ctx.dataSource?.TrxId,
          ritId: _ctx.activeRitId,
          show: _ctx.isShowDialogUpdateExpense,
          onHideDialogUpdateExpense: _ctx.hideDialogUpdateExpense,
          onReloadData: _ctx.reloadUpdateExpense
        }, null, 8, ["trxId", "ritId", "show", "onHideDialogUpdateExpense", "onReloadData"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDialogFuelingTransactionRevision)
      ? (_openBlock(), _createBlock(_component_FuelingTransactionRevision, {
          key: 2,
          trxId: _ctx.dataSource?.TrxId,
          ritId: _ctx.activeRitId,
          dieselExpenseDetailList: _ctx.dieselExpenseDetailList,
          show: _ctx.isShowDialogFuelingTransactionRevision,
          onHideDialogFuelingTransactionRevision: _ctx.hideDialogFuelingTransactionRevision,
          onReloadData: _ctx.reloadUpdateExpense
        }, null, 8, ["trxId", "ritId", "dieselExpenseDetailList", "show", "onHideDialogFuelingTransactionRevision", "onReloadData"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDialogExpenseHistory)
      ? (_openBlock(), _createBlock(_component_ExpenseHistory, {
          key: 3,
          trxId: _ctx.dataSource?.TrxId,
          ritId: _ctx.activeRitId,
          show: _ctx.isShowDialogExpenseHistory,
          onHideDialogExpenseHistory: _ctx.hideDialogExpenseHistory
        }, null, 8, ["trxId", "ritId", "show", "onHideDialogExpenseHistory"]))
      : _createCommentVNode("", true),
    (_ctx.isShowApproveDialog)
      ? (_openBlock(), _createBlock(_component_ApproveModal, {
          key: 4,
          id: _ctx.dataId,
          show: _ctx.isShowApproveDialog,
          onHideApproveDialog: _ctx.hideApproveDialog,
          onSubmit: _ctx.onSubmitConfirmation
        }, null, 8, ["id", "show", "onHideApproveDialog", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDialogUpdateOtherRevenue)
      ? (_openBlock(), _createBlock(_component_UpdateOtherRevenues, {
          key: 5,
          show: _ctx.isShowDialogUpdateOtherRevenue,
          trxId: _ctx.dataSource?.TrxId,
          ritId: _ctx.activeRitId,
          revenues: _ctx.dataRitDetail?.RitOtherRevenues,
          onHideDialog: _ctx.hideDialogUpdateOtherRevenue,
          onReloadData: _ctx.reloadUpdateOtherExpense
        }, null, 8, ["show", "trxId", "ritId", "revenues", "onHideDialog", "onReloadData"]))
      : _createCommentVNode("", true)
  ], 64))
}